import Loader from "components/loader";


const NewWidget = ({ icon, title, isLoading, value, subValue, subtitle, secondTitle, secondSubtitle, thirdTitle, thirdSubtitle }) => {
    return <div className="flex gap-4 items-center py-2 bg-white border rounded-3xl justify-between px-4">
        <div className="flex gap-2 items-center">
            <div className="rounded-full bg-gray-50 p-3">{icon}</div>
            <span className="text-xs text-gray-600 font-semibold">{title?.toUpperCase()}</span>
        </div>
        {isLoading ?
            <Loader small={true} /> :
            <div className="flex flex-col gap-0 items-center">
                <span className="text-sm font-semibold">{value} </span>
                {subValue && <span className="text-[70%] font-semibold">{subValue}</span>}
            </div>
        }
    </div>
}

export default NewWidget;
